import React, { type JSX } from 'react';
import { heatMapPercentageClassName } from '../TalentTreeNode/TalentTreeNode';

const formatPercentValue = (value: number, fractionDigits: number): string => {
  const roundedVal = Math.floor(value * 1000) / 10;
  return roundedVal.toFixed(fractionDigits);
};

export type TalentTreePercentBadgeProps = {
  percent: number;
  largeText?: boolean;
};

export default function TalentTreePercentBadge({
  percent,
  largeText = false,
}: TalentTreePercentBadgeProps): JSX.Element {
  const className = heatMapPercentageClassName(percent);
  return (
    <div
      className={`talent-tree-percentage_badge talent-tree-percentage_badge--${className} ${
        largeText ? 'talent-tree-percentage_badge--large-text' : ''
      }`}
    >
      <span className={'talent-tree-percentage_badge__value--1-decimal'}>
        {formatPercentValue(percent, 1)}
      </span>
      <span className={'talent-tree-percentage_badge__value--0-decimals'}>
        {formatPercentValue(percent, 0)}
      </span>
      %
    </div>
  );
}
